<h1 mat-dialog-title [innerHtml]="(message$|async)" ></h1>
<div mat-dialog-actions>
  <button mat-button (click)="closeDialog()">Ok</button>
</div>
